import  React from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import Divider from 'material-ui/Divider';
import {inject} from 'mobx-react'

import {
	SIDEBARS_BOTTOM,
	SIDEBARS_TOP,
	SIDEBARS_TOP_EXAM_PREP,
} from '../../../constants/sideBar';
import {TOPIC_TYPE_NAME} from 'constants/topicTypes';

@withRouter
@inject('sideBarStore')
@inject('userStore')
@inject('examPrepHeaderStore')

export default class UserLogIn extends React.Component{

  componentDidMount(){
    this.routerListener = this.props.history.listen(() => {
      this.props.sideBarStore.deactivate();
    });
  }

  componentWillUnmount(){
    this.routerListener();
  }

  getTitle = (type, title) => {
    switch (type) {
      case 'cct':
        return title.replace('MICGP ', '');
      default:
        return title;
    }
  };

  getResourcesTitle = (type) => {
    switch (type) {
      case 'cct':
        return 'CCT Practice Cases';
      case 'ckt':
        return 'CKT Revision Summaries';
      default:
        return '';
    }
  };
	
	renderButtons = (topic) => {
    const {tutorial_type, title} = topic || {};
    const showResources = tutorial_type === 'cct' || tutorial_type === 'ckt';

    return (
      <div className='sidebar-exam-prep'>
        {showResources && (
          <NavLink to={`/exam-prep/${topic.id}/practice-cases?resourse_type=${tutorial_type}`}>
            <div className="btn blue rounded sidebar-exam-prep-buttons">
              <span>{this.getResourcesTitle(tutorial_type)}</span>
            </div>
          </NavLink>
        )}
        <NavLink className={``} to={`/exam-prep/topic/${topic.id}`}>
          <div className="btn blue rounded sidebar-exam-prep-buttons">
            <span>{this.getTitle(tutorial_type, title)}</span>
          </div>
        </NavLink>
        <NavLink className="" to={`/exam-prep/${topic.id}/topics`}>
          <div className="btn blue rounded sidebar-exam-prep-buttons">
            <span>CLINICAL TOPICS</span>
          </div>
        </NavLink>
        <NavLink className="" to={`/exam-prep/${topic.id}/reimbursed`}>
          <div className="btn blue rounded sidebar-exam-prep-buttons">
            <span>{`${TOPIC_TYPE_NAME[topic.tutorial_type]} REIMBURSEMENT`}</span>
          </div>
        </NavLink>
      </div>
    );
  };

  handleShowButtons = (topic, showButtons) => {
    if (showButtons) {
      return this.renderButtons(topic);
    }

    return null;
  };

	render() {
		const {isExamPrepUser, user} = this.props.userStore;
    const {topic, showButtons} = this.props.examPrepHeaderStore;
		const showExamPrep = isExamPrepUser && user.role !== 'admin';
		const topSidebarTabs = showExamPrep ? SIDEBARS_TOP_EXAM_PREP : SIDEBARS_TOP;
		const topSidebar = topSidebarTabs.map((item, index) => {
			const {icon, title, link} = item;

			return user.user_type === 4 && title === 'Tracker' ? null : (
				<NavLink
					key={index}
					exact
					to={link}
					activeClassName="active"
					className={`sidebar-item ${title === 'Live events' ? 'show-hide-side-bar-item' : ''}`}>
					<i className={icon} />
					{title}
				</NavLink>
			)
		});
		const bottomSidebar = SIDEBARS_BOTTOM.map((item, index) => {
			const {icon, title, link} = item;

			return (
				<NavLink
					key={index}
					to={link}
					exact
					activeClassName="active"
					className="sidebar-item">
					<i className={icon} />
					{title}
				</NavLink>
			)
		});

		return(
			<div className="sidebar-wrapper">
				{topSidebar}
				{this.handleShowButtons(topic, showButtons)}
				<Divider className="sidebar-divider" />
				{bottomSidebar}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/core/containers/UserLogIn.js